module.exports = __webpack_public_path__ + "static/media/menu_terms&conditions_hoverActive.24ec9647.svg";